var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 9.49994L2.6665 11.9999L12.3087 16.8211C12.4399 16.8866 12.5055 16.9194 12.5743 16.9324C12.6352 16.9438 12.6978 16.9438 12.7587 16.9324C12.8275 16.9194 12.8931 16.8866 13.0243 16.8211L22.6665 11.9999L17.6665 9.49994M7.6665 14.4999L2.6665 16.9999L12.3087 21.8211C12.4399 21.8866 12.5055 21.9194 12.5743 21.9324C12.6352 21.9438 12.6978 21.9438 12.7587 21.9324C12.8275 21.9194 12.8931 21.8866 13.0243 21.8211L22.6665 16.9999L17.6665 14.4999M2.6665 6.99994L12.3087 2.17883C12.4399 2.11324 12.5055 2.08044 12.5743 2.06753C12.6352 2.0561 12.6978 2.0561 12.7587 2.06753C12.8275 2.08044 12.8931 2.11324 13.0243 2.17883L22.6665 6.99994L13.0243 11.8211C12.8931 11.8866 12.8275 11.9194 12.7587 11.9324C12.6978 11.9438 12.6352 11.9438 12.5743 11.9324C12.5055 11.9194 12.4399 11.8866 12.3087 11.8211L2.6665 6.99994Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersIcon);
export default __webpack_public_path__ + "static/media/layersIcon.693dc3b6ede59b397511a456ca4c2394.svg";
export { ForwardRef as ReactComponent };